import '../../helper/global-jquery';

const RESULT_LISTS = $(
	`.ce--vd_reviewers_list .vd-result-list,
	.ce--vd_authorities_list .vd-result-list,
	.ce--vd_courses_list .vd-result-list,
    .ce--solr_pi_results .results-list`
);

const URL = window.location.href;


RESULT_LISTS.each((index, el) => {
	if (el && URL.match(/\?./)) {
		const $anchor = $(el);
		const yOffset = 200;

		$([document.documentElement, document.body]).animate({
			scrollTop: $anchor.offset().top - yOffset,
		}, 400);
	}
});

// EVENTS SEARCH
const EVENT_SEARCH_FORM = $('.ce--vd_events_search .vd-form');
const EVENT_RESULT_LIST = $('.ce--vd_events_search .event-list');
const INPUTS = EVENT_SEARCH_FORM.find('.form-control, input[type="checkbox"]').toArray();

const scrollIntoResults = () => {
	console.log(INPUTS);

	const formHasValue = INPUTS.some((el) => {
		let hasValue = false;

		if (el.type === 'checkbox') hasValue = el.checked;
		if (el.type === 'text' || el.tagName === 'SELECT') hasValue =  el.value ? true : false;

		return hasValue;
	})

	if (formHasValue) {
		const yOffset = 200;

		$([document.documentElement, document.body]).animate({
			scrollTop: EVENT_RESULT_LIST.offset().top - yOffset,
		}, 400);
	}
}

scrollIntoResults();

$(document).on('load', () => scrollIntoResults());